import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateSupport,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({ ...select_data });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "emails") {
      const emailArray = value
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email);
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        emails: emailArray,
      }));
    } else {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.companyName)
      newErrors.companyName = "Company Name is required";
    if (
      !update_modal_data.emails ||
      !Array.isArray(update_modal_data.emails) ||
      update_modal_data.emails.length === 0
    )
      newErrors.emails = "At least one email is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to update this data?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        Swal.fire("Changes are not saved", "", "info");
        return;
      }

      try {
        const { _id, companyName, emails } = update_modal_data;
        if (!_id) throw new Error("ID is not defined");

        const payload = {
          companyName,
          emails,
        };

        const res = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/api/v4/company-email/${_id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        // ✅ Log to check the real response structure
        console.log("API response:", res);

        // ✅ Show success if status is 2xx
        Swal.fire("Update success", "", "success");
        onUpdateSupport(update_modal_data);
        setRen(!ren);
        set_update_data_modal_Show(false);
      } catch (error) {
        Swal.fire("Update failed", "", "error");
        console.error("Update Error:", error);
      }
    });
  };
  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Company Support Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Company Name *</Form.Label>
              <Form.Control
                type="text"
                name="companyName"
                value={update_modal_data.companyName || ""}
                onChange={handleChange}
                isInvalid={!!errors.companyName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.companyName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Emails *</Form.Label>
              <Form.Control
                type="text"
                name="emails"
                placeholder="email1@example.com, email2@example.com"
                value={
                  Array.isArray(update_modal_data.emails)
                    ? update_modal_data.emails.join(", ")
                    : ""
                }
                onChange={handleChange}
                isInvalid={!!errors.emails}
              />
              <Form.Control.Feedback type="invalid">
                {errors.emails}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Company Support
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
